import React, {useEffect, useState} from "react";
import {Button, Input, Modal, Form, Radio, Popconfirm} from "antd";
import "./ApplicantSources.scss"
import { openNotificationWithIcon } from "@frontend/src/utilities/notificationWithIcon";
import { applicantSourcesService } from "@frontend/src/core/services/applicant_sources_service";
import { DndProvider} from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Table } from 'antd';

const ApplicantSources = ({
                            organizationId
                     }) => {
  const [showModal,setShowModal] = useState(false)
  const [sourceName,setSourceName] = useState('')
  const [selectedSource,setSelectedSource] = useState(null)
  const [isCreating,setIsCreating] = useState(null)
  const [sourcesList,setSourcesList] = useState([])
  const [isEditing,setIsEditing] = useState(null)
  const [isDeleting,setIsDeleting] = useState(null)
  const columnList = [{id:1, title:'Fuente de Origen', dataIndex:'name', ellipsis: true},
    {id:2, title: 'Usuarios asociados', dataIndex:'assigned_count', align: 'center', width: 90},
    {id:3, title: '', dataIndex:'', align: 'center', width: 90, fixed: 'right', render: (row) => sourceOptions(row)}]


  const sourceOptions = (source) => {
    return (
      <div>
        <span className="action-box" onClick={() => onChangeState(source)}>
          <i className="fa fa-pencil"></i>
        </span>
        <Popconfirm
          title="¿Estás seguro de eliminar la fuente de origen?"
          onConfirm={() => destroySource(source)}
          onCancel={() => {}}
          okText="Eliminar"
          cancelText="Cancelar"
        >
          <span className="action-box">
            <i className="fa fa-times"></i>
          </span>
        </Popconfirm>
      </div>
    )
  }

  const showSourceModalList = () => {
    return (
      <Modal
        title={"Crear nueva fuente"}
        visible={showModal}
        onCancel={() => setShowModal(false)}
        onOk={() => selectedSource ? updateSource() : createSource()}
        cancelText={"Cancelar"}
        okText={"Guardar"}>
        <Form
          layout={'vertical'}>
          <Form.Item label={"Nombre de la fuente"}>
            <Input onChange={(e) => setSourceName(e.target.value)}
                   value={selectedSource && !sourceName ? selectedSource.name : sourceName}/>
          </Form.Item>
        </Form>
      </Modal>
    )
  }

  const onChangeState = (category) => {
    setSelectedSource(category)
    setShowModal(true)
  }

  const createSource = () => {
    applicantSourcesService
      .createNewSource({
          name:sourceName,
          organization_id:
          organizationId},
        (success) => {
          setIsCreating(success)
          openNotificationWithIcon(
            "success",
            "Fuente de origen creada correctamente",
            ""
          );
        },
        (error) => console.error(error))
  }

  const destroySource = (row) => {
    applicantSourcesService
      .deleteSource(
        row.id,
        (success) => {
          setIsDeleting(success)
          openNotificationWithIcon(
            "success",
            "Fuente de origen borrada correctamente",
            ""
          );
        },
        (error) => console.error(error))
  }

  const updateSource = () => {
    applicantSourcesService
      .editSource({
          id: selectedSource.id,
          name: sourceName,
        },
        (success) => {
          setIsEditing(success)
          openNotificationWithIcon(
            "success",
            "Fuente de origen actualizada correctamente",
            ""
          );
        },
        (error) => console.error(error))
  }

  const bringConsultants = () => {
    applicantSourcesService.allSources(
      (success) => setSourcesList(success),
      (error) => console.error(error))
  }


  useEffect(() => {
    if(showModal && selectedSource) {
      setSourceName(selectedSource.name)
    }
    else {
      setSourceName("")
    }
  }, [showModal])

  useEffect(() => {
    if(isCreating){
      bringConsultants()
      setIsCreating(null)
      setShowModal(false)
    }
  }, [isCreating])

  useEffect(() => {
    if(isDeleting){
      bringConsultants()
      setIsDeleting(null)
    }
  }, [isDeleting])

  useEffect(() => {
    if(isEditing){
      bringConsultants()
      setShowModal(false)
      setIsEditing(null)
    }
  }, [isEditing])

  useEffect(() => {
  }, [sourcesList])

  useEffect(() => {
    bringConsultants()
  },[])


  return (
    <DndProvider backend={HTML5Backend}>
      <div>
        <div className={'card settings-card'}>
          <div className='card-header'>
            <h1 className='title'>Fuentes de origen</h1>
          </div>
          <div className='card-body'>
            <div>
              <Table columns={columnList} dataSource={sourcesList} />
            </div>
            <div className='button-add'>
              <Button onClick={() => onChangeState(null)}>Crear nueva fuente</Button>
            </div>
          </div>
        </div>
        {showModal && showSourceModalList()}
      </div>
    </DndProvider>
  )
}

export default ApplicantSources;